import { G_elements } from "./globals/elements";

/**
 *
 * @param {TorusElement} element
 * @param {"Group" | "Main" | "Target" | "Container"} name
 */
const removeInstance = (element, name) => {
  /** Remove element from the global map */
  G_elements.delete(element);

  /** Remove Group instance on the element */
  delete element.Torus?.[name];

  /** If `Torus` object is empty remove it */
  if (element.Torus && !Object.keys(element.Torus).length) {
    delete element.Torus;
  }
};

export default removeInstance;
